const sentenceCase = (str) => {
    const s = str ? str : '';
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
};
const addSeparator = (str, separator = ',') => (str ? str + separator : '');
export const getAddressLabel = (address) => {
    const cs = sentenceCase;
    const sep = addSeparator;
    const { street, building, municipality, postalCode, city, region } = address;
    const streetAndBuilding = `${cs(street)} ${cs(building)}`.trim();
    const indexAndCity = `${cs(postalCode)} ${cs(city)}`.trim();
    return `${sep(streetAndBuilding)} ${sep(cs(municipality))} ${sep(indexAndCity)} ${cs(region)}`.trim();
};
